import React, {FC, useState} from 'react';
import {BSButton} from 'bodyspec-shared-components';
import {HubSpotForm} from 'components/ContentPagesComponents/HubSpotForm';
import LaptopSizeWrapper from 'components/ContentPagesComponents/LaptopSizeWrapper';
import DynamicAsset from 'components/DynamicAsset';
import {navigate} from 'gatsby';

import './index.scss';

interface ArticleButtonProps {
	buttonText?: string;
	buttonLink?: string;
	buttonForm?: string;
}

const isExternal = (link: string): boolean => {
	if (link.startsWith('https://www.bodyspec.com')) {
		return false;
	} else if (link.startsWith('/')) {
		return false;
	} else if (!link.startsWith('http')) {
		return false;
	}
	return true;
};

const ArticleButton: FC<ArticleButtonProps> = ({buttonText, buttonLink, buttonForm}) => {
	const [show, setShow] = useState(false);
	const toggle = () => setShow(!show);

	if (!buttonText) {
		return null;
	} else if (buttonLink) {
		if (isExternal(buttonLink)) {
			return (
				<BSButton variant='dark' size='lg' onClick={() => window.open(buttonLink, '_blank')}>
					{buttonText}
				</BSButton>
			);
		}

		return (
			<BSButton variant='dark' size='lg' onClick={() => navigate(buttonLink)}>
				{buttonText}
			</BSButton>
		);
	}

	if (buttonForm) {
		const Form = HubSpotForm(buttonForm);
		return (
			<>
				<BSButton variant='dark' size='lg' onClick={toggle}>
					{buttonText}
				</BSButton>
				<Form show={show} onClose={toggle} />
			</>
		);
	}

	return null;
};

interface ArticlePanelProps {
	imageSrc: string;
	title: string;
	text: string;
	buttonText?: string;
	buttonLink?: string;
	buttonForm?: string;
}

const ArticlePanel: FC<ArticlePanelProps> = (props) => {
	const {imageSrc, title, text} = props;
	return (
		<LaptopSizeWrapper>
			<div className='article-container d-flex flex-row w-100'>
				<article className='d-flex flex-row justify-content-between article-container--article'>
					<div className='article-container--article--img'>
						<DynamicAsset imageSrc={imageSrc} alt='Article Header' className='img-fluid' />
					</div>
					<div className='article-container--article--content'>
						<h3>{title}</h3>
						<p>{text}</p>
						<ArticleButton {...props} />
					</div>
				</article>
			</div>
		</LaptopSizeWrapper>
	);
};

export default ArticlePanel;
